















































































import { Vue, Component } from 'vue-property-decorator';
import ProcessEdit from '@/views/professionalWork/workflow/processEdit/processEdit.vue';
import dayjs from 'dayjs';
import ProcessDialog from '@/views/professionalWork/workflow/processManagement/unit/processDialog.vue';
import AdvancedSetting from '@/views/professionalWork/workflow/advancedSetting/advancedSetting.vue';
import { processServe } from '@/api/installServer';

@Component({
  components: { ProcessDialog, ProcessEdit, AdvancedSetting },
})
export default class ProcessManagement extends Vue {
  showEditMark = false;
  showAdvancedSetting = false;
  addNum: any = 1; //新增权限分组
  group: any = ''; //分组名
  dateTime: any = dayjs(new Date()).format('YYYY/MM/DD hh:mm:ss'); //更新时间
  editData: any;

  form: object = {
    name: '',
    resource: 'company',
    type: ['chakan', 'daochu', 'shanchu'],
  };

  groupData: any = [];
  otherGroupObj: any = {
    formList: [],
  };

  advancedSettingData: any;

  mounted() {
    this.getData();
  }

  // 获取数据 分别获取分组和全部数据 根据groupId分组
  async getData() {
    processServe
      .getProcessData({})
      .then((res: any) => {
        // this.groupData = res.data;
        this.getFrom(res.data);
      })
      .catch((e: any) => {});
  }

  // 获取数据 分别获取分组和全部数据 根据groupId分组
  getFrom(groupData: any) {
    processServe
      .getFlowFormData({})
      .then((res: any) => {
        const data = res.data;
        groupData.forEach((group: any, index: any) => {
          this.otherGroupObj.formList = [];
          groupData[index].formList = [];
          data.forEach((form: any) => {
            if (form.groupId === group.id) {
              groupData[index].formList.push(form);
            }
          });
        });

        data.forEach((form: any) => {
          if (form.groupId === '') {
            this.otherGroupObj.formList.push(form);
          }
        });
        this.groupData = groupData;
      })
      .catch((e: any) => {});
  }

  // 流程新增编辑
  showEdit(type: any, data: any) {
    if (type === 'add') {
      this.editData = data;
      this.showEditMark = true;
    }
    if (type === 'edit') {
      this.editData = data;
      this.showEditMark = true;
    }
  }

  // 流程高级设置编辑
  showEditAdvancedSetting(data: any) {
    console.log(data);
    this.advancedSettingData = data;
    this.showAdvancedSetting = true;
  }

  // 删除停用弹出框控制
  groupDialog(title: any, type: any, data?: any) {
    console.log(data);
    const processDialog: any = 'processDialog';
    const processManagementComponent: any = this.$refs[processDialog];
    processManagementComponent.showDialog(title, type, data);
  }

  // 新建分组
  addData(data: any, type: any, item: any) {
    if (type === 'add') {
      this.group = data;
      processServe
        .addProcessData({
          name: data,
        })
        .then((res: any) => {
          if (res.code === '200') {
            this.$message.success('添加成功');
            this.getData();
          }
        })
        .catch(() => {
          this.$message.error('添加失败,请稍后重试!');
        });
    }

    // 编辑
    if (type === 'update') {
      this.group = data;
      processServe
        .updateProcessData({
          name: data,
          id: item.id,
        })
        .then((res: any) => {
          if (res.code === '200') {
            this.$message.success('修改成功');
            this.getData();
          }
        })
        .catch(() => {
          this.$message.error('修改失败,请稍后重试!');
        });
    }

    // 删除分组
    if (type === 'delete') {
      console.log(item);
      const idList: any = [item.id];
      processServe.deleteProcessData(idList).then((res: any) => {
        if (res.code === '200') {
          this.$message.success('删除成功');
          this.getData();
        }
      });
      this.addNum--;
    }

    // 启用
    if (type === 'enable') {
      const idList: any = item.id;
      processServe
        .enableFlowForm({
          idList: idList,
          groupContent: data, // 目前没有接值的地方，
          enable: true,
        })
        .then((res: any) => {
          if (res.code === '200') {
            this.$message.success('启用成功');
            this.getData();
          }
        });
    }

    // 停用
    if (type === 'unEnable') {
      const idList: any = item.id;
      processServe
        .enableFlowForm({
          idList: idList,
          groupContent: data, // 目前没有接值的地方，
          enable: false,
        })
        .then((res: any) => {
          if (res.code === '200') {
            this.$message.success('停用成功');
            this.getData();
          }
        });
    }
  }

  // 编辑组件 返回方法
  back() {
    this.showEditMark = false;
    this.showAdvancedSetting = false;
    this.getData();
  }
}
